import i18n from '@/i18n';

const PageActions = () =>
  import(/* webpackChunkName: "actions" */ '@/pages/actions/Actions.vue');
const ActionsTop = () =>
  import(/* webpackChunkName: "actions" */ '@/pages/actions/ActionsTop.vue');
const ActionsFilter = () =>
  import(/* webpackChunkName: "actions" */ '@/pages/actions/ActionsFilter.vue');

export const ACTIONS_LIST_ROUTE_NAME = 'actions-list';

export default {
  getActionsRoute() {
    return {
      path: 'actions',
      name: ACTIONS_LIST_ROUTE_NAME,
      components: {
        default: PageActions,
        top: ActionsTop,
        'right-drawer': ActionsFilter,
      },
      meta: {
        authorizations: ['isMy360'],
        title: 'actions',
        icon: i18n.t('message.actions.icon'),
      },
    };
  },
};
